import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { LogOut, ChevronDown, ShieldCheck } from 'lucide-react';
import type { User } from '@/lib/types';
import { cn } from '@/lib/cn';

interface Props { user: User; onLogout: () => void }

export function UserMenu({ user, onLogout }: Props) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-white/10 transition-colors text-white/95">
          <span className="w-7 h-7 rounded-full bg-signal text-ink font-bold text-xs flex items-center justify-center">
            {user.username.slice(0, 1).toUpperCase()}
          </span>
          <span className="hidden sm:flex flex-col items-start leading-tight">
            <span className="text-xs font-semibold">{user.username}</span>
            <span className="text-[10px] uppercase tracking-wider text-white/70">{user.role}</span>
          </span>
          <ChevronDown className="w-4 h-4 opacity-70" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end" sideOffset={8}
          className={cn(
            'z-50 min-w-[200px] rounded-xl border border-slate-200 bg-white p-1 shadow-lg',
            'data-[state=open]:animate-in data-[state=open]:fade-in',
          )}
        >
          <div className="px-2 py-2">
            <div className="text-sm font-semibold text-ink">{user.username}</div>
            <div className="text-xs text-slate-500 flex items-center gap-1.5 mt-0.5">
              <ShieldCheck className="w-3 h-3" />
              {user.role}
            </div>
          </div>
          <DropdownMenu.Separator className="h-px bg-slate-100 my-1" />
          <DropdownMenu.Item
            onSelect={onLogout}
            className="text-sm text-ink hover:bg-slate-50 rounded-lg px-2 py-1.5 cursor-pointer flex items-center gap-2 outline-none"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
